namespace GeniuzPOS.PosShift {
    export interface LookupLastPassportDataforVatRefundRow {
        Passport?: string;
        FristName?: string;
        LastName?: string;
        Nation?: string;
        Addressno?: string;
        Street?: string;
        District?: string;
        City?: string;
        Province?: string;
        ZipCode?: string;
        Country?: string;
        Email?: string;
    }

    export namespace LookupLastPassportDataforVatRefundRow {
        export const idProperty = 'Passport';
        export const nameProperty = 'Passport';
        export const localTextPrefix = 'PosShift.LookupLastPassportDataforVatRefund';
        export const lookupKey = 'LookupLastPassportDataforVatRefund';

        export function getLookup(): Q.Lookup<LookupLastPassportDataforVatRefundRow> {
            return Q.getLookup<LookupLastPassportDataforVatRefundRow>('LookupLastPassportDataforVatRefund');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Passport = "Passport",
            FristName = "FristName",
            LastName = "LastName",
            Nation = "Nation",
            Addressno = "Addressno",
            Street = "Street",
            District = "District",
            City = "City",
            Province = "Province",
            ZipCode = "ZipCode",
            Country = "Country",
            Email = "Email"
        }
    }
}
